import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";

import {setCurrentRiddleRange} from "../../../ducks/duck-screen";
import {setCurrentLevel} from "../../../ducks/duck-game";

import UnlockLevelModal from "./unlock-level-modal";
import {navigateToLevelList} from "../../../ducks/duck-router";


function UnlockLevelModalContainer(props) {
	return (
		<UnlockLevelModal {...props}/>
	);
}

UnlockLevelModalContainer.propTypes = {
	currentScreen: PropTypes.string.isRequired,

	modal: PropTypes.object.isRequired,

	removeModalWindow: PropTypes.func.isRequired,
	goBack: PropTypes.func.isRequired,
	setCurrentRiddleRange: PropTypes.func.isRequired,
	setCurrentLevel: PropTypes.func.isRequired,
	navigateToLevelList: PropTypes.func.isRequired,
}



export default connect(
	null,
	{
		setCurrentRiddleRange,
		setCurrentLevel,
		navigateToLevelList
	}
)(UnlockLevelModalContainer);
